import React, { useCallback, useMemo, useState } from 'react';
import { Button, CardActions, CardContent, Grid, MenuItem, TextField, Card, Typography } from '@material-ui/core';
import { ThemeWrapper } from '../common/ThemeWrapper';
import { Motions } from '../../constants/MinLiveLength/Motions';
import { HoseSeries } from '../../constants/HoseSeries';
import { getOr, flowRight } from 'lodash/fp';
import { findByValue } from '../../utils/lookups';
import { ContentContainer } from '../common/ContentContainer';
import { useLabelStyles, useStyles } from '../common/styles';
import '../../Style.css';

export const MinLiveLengthCalculator = () => {
    const [selectedMotion, setselectedMotion] = useState('');
    const [selectedModel, setSelectedModel] = useState('');
    const [selectedProduct, setSelectedProduct] = useState('');
    const [inputFormat, setInputFormat] = useState('');
    const [inputFormat0, setInputFormat0] = useState(undefined);
    const [outputFormat, setOutputFormat] = useState('');
    const [liveHoseLength, setLiveHoseLength] = useState('');
    const [BendRadius, setBendRadius] = useState('');

    const productChoices = useMemo(
        () => flowRight(
            getOr([], 'products'),
            findByValue(selectedProduct)
        )(HoseSeries),
        [selectedProduct]
    );

  


    const modelInfo = useMemo(
        () => findByValue(selectedModel)(productChoices),
        [selectedModel, productChoices]
    );


    const handleMotionSelection= (e) => {
        e.persist();
        setselectedMotion(e.target.value);
       
 
    }

    const handleModelSelection =(e) => {
        e.persist();
        setSelectedModel(e.target.value);
        setBendRadius(getOr('', 'BR', findByValue(e.target.value)(productChoices)));
    }

    const handleHoseSelection= (e) => {
        e.persist();
        setSelectedProduct(e.target.value);

    }


    const handleInputFormatChange = (e) => {
        e.persist();
        setInputFormat(e.target.value);
    }

    const handleBendRadiusChange = (e) => {
        e.persist();
        setBendRadius(e.target.value);
    }

    const handleInputFormat0Change = useCallback((e) => {
        setInputFormat0(e.target.value);
    }, [setInputFormat0]);

    const motionDesc = flowRight(
        getOr('', 'motiondesc'),
        findByValue(selectedMotion)
    )(Motions);

    const motionName = flowRight(
        getOr('', 'motionname'),
        findByValue(selectedMotion)
    )(Motions);

    const imgSrc2 = flowRight(
        getOr('', 'image3'),
        findByValue(selectedMotion)
    )(Motions);

    const inputformatlabel = flowRight(
        getOr('', 'inputformat'),
        findByValue(selectedMotion)
    )(Motions);

    const outputformatlabel = flowRight(
        getOr('', 'outputformat'),
        findByValue(selectedMotion)
    )(Motions);

    const reset = useCallback(() => {
        setSelectedProduct();
        setSelectedModel();
        setselectedMotion('');
        setInputFormat('');
        setInputFormat0('');
        setLiveHoseLength('');
        setOutputFormat('');
        setBendRadius('');
    }, [
        setSelectedProduct,
        setSelectedModel,
        setselectedMotion,
        setInputFormat,
        setInputFormat0,
        setLiveHoseLength,
        setOutputFormat,
        setBendRadius,
    ]);



    const calculate = useCallback(() => {
        var liveLength = null;
        var projLength = null;
        var deflection = null;
        var hangLength1 = null;
        var hangLength2 = null;

        if (selectedMotion !== 'Traveling Loop (Movement in Two Directions)') {
            deflection = inputFormat;
        } else {
            deflection = inputFormat;
        }
        

        // different formulas used
        if (selectedMotion === 'Angular Motion') {
            liveLength = (Math.PI * BendRadius * deflection / 180) + 2 * getOr('', 'OD', modelInfo);
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));
        } else if (selectedMotion === 'Offset (End is free to move "out of line")') {
            // to warn about travel been more than 25% of Bend Radius 08/29/2011 aok
            if (deflection > (BendRadius / 4)) {
                window.alert('Offset T=' + deflection + '" is more than 25% of Bend Radius R=' + BendRadius + '"\nIn dynamic application T should never exceed 25% of R\nPlease call Penflex for details @ 610-367-2260');
            }

            liveLength = Math.sqrt(6 * (BendRadius * deflection) + Math.pow(deflection, 2));
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));

            projLength = Math.sqrt((Math.pow(liveLength, 2) - Math.pow(deflection, 2)));
            setOutputFormat(parseFloat(projLength.toPrecision(3)));
        } else if (selectedMotion === 'Offset (Move is restricted to up and down)') {
            // to warn about T - Travel been more than 25% of Bend Radius 08/29/2011 aok
            if (deflection > (BendRadius / 4)) {
                window.alert('Offset T=' + deflection + '" is more than 25% of Bend Radius R=' + BendRadius + '"\nIn dynamic application T should never exceed 25% of R\nPlease call Penflex for details @ 610-367-2260');
            }

            liveLength = Math.sqrt(20 * (BendRadius * deflection));
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));

            projLength = Math.sqrt((Math.pow(liveLength, 2) - Math.pow(deflection, 2)));
            setOutputFormat(parseFloat(projLength.toPrecision(3)));

        } else if (selectedMotion === 'Traveling Loop (Constant Radius)') {
            liveLength = 4 * BendRadius + deflection / 2;
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));

            hangLength1 = 1.43 * BendRadius + deflection / 2;
            setOutputFormat(parseFloat(hangLength1.toPrecision(3)));

        } else if (selectedMotion === 'Traveling Loop (Variable Radius)') {
            liveLength = 4 * BendRadius + 1.57 * deflection;
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));

            hangLength1 = 1.43 * BendRadius + 0.79 * deflection;
            hangLength2 = 1.43 * BendRadius + 0.50 * deflection;

            setOutputFormat("H1=" + hangLength1.toFixed() + "; H2=" + hangLength2.toFixed());

        } else if (selectedMotion === 'Traveling Loop (Movement in Two Directions)') {
            liveLength = 4 * BendRadius + 1.57 * inputFormat0 + inputFormat / 2;
            setLiveHoseLength(parseFloat(liveLength.toPrecision(3)));

            hangLength1 = 1.43 * BendRadius + 0.785 * inputFormat0 + inputFormat / 2;
            hangLength2 = 1.43 * BendRadius + 0.50 * inputFormat0;

            setOutputFormat("H1=" + hangLength1.toPrecision(2) + "; H2=" + hangLength2.toPrecision(2));
        }
    }, [
        selectedMotion, 
        inputFormat, 
        modelInfo, 
        inputFormat0,
        BendRadius
    ]);

    const classes = useStyles();
    const inputProps = {
        classes:{
            root: classes.inputRoot,
            disabled: classes.disabled
        }
    };
    
    const labelClasses = useLabelStyles();
    const labelProps = {
        classes:{
            root: labelClasses.root,
        }
    };

    return (
     //test
        <ThemeWrapper title={'Penflex - Min Live Length Calculator'}>   
           <style>
               {`@media print {html,body{height:100%;margin:0;padding:0;zoom:85%;}
 @page {
	size: A4 portrait;
	max-height:100%;
  
	}
}}`}
               </style>    
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    id="product-selection"
                                    label={'Choose Hose Series'}
                                    value={selectedProduct}
                                    onChange={handleHoseSelection}
                                    fullWidth
                                >
                                    {
                                        HoseSeries.map((option) => (
                                            <MenuItem key={option.label} value={option.value} >
                                                {option.label}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    label={'Select a Specific Product'}
                                    value={selectedModel}
                                    onChange={handleModelSelection}
                                    disabled={!selectedProduct || selectedProduct.legnth < 1}
                                    fullWidth
                                >
                                    {
                                        productChoices.map((option) => (
                                            <MenuItem key={option.label} value={option.value} >
                                                {option.label}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    select
                                    id="motion"
                                    label={'Select the Motion'}
                                    value={selectedMotion}
                                    onChange={handleMotionSelection}
                                    disabled={!selectedModel || selectedModel.legnth < 1}
                                    fullWidth
                                >
                                    {
                                        Motions.map((option) => (
                                            <MenuItem key={option.label} value={option.value} >
                                                {option.label}
                                            </MenuItem>
                                        ))
                                    }
                                </TextField>
                            </Grid>
                           
                       
                       {
                           selectedMotion === 'Traveling Loop (Movement in Two Directions)' && (
                               <Grid item xs={12}>
                                   <TextField
                                       label={<span>{`Travel-T1 (in.)`}</span>}
                                       InputLabelProps={labelProps}
                                       value={inputFormat0}
                                       fullWidth
                                       type="number"
                                       onChange={handleInputFormat0Change}
                                   />
                               </Grid>
                           )
                       }
                       <Grid item xs={12}>
                           <TextField
                               label={<span>{inputformatlabel}</span>}
                               InputLabelProps={labelProps}
                               value={inputFormat}
                               onChange={handleInputFormatChange}
                               fullWidth
                               type="number"
                           />
                       </Grid>
                  
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        
                            <CardContent>
                                <Typography variant="h6" component="h2">
                                    {motionName}
                                </Typography>
                                <Typography color="textSecondary" gutterBottom variant="caption">
                                    {motionDesc}
                                </Typography>
                            </CardContent>
                        
                    </Grid>
                </Grid>
                </CardContent>
                <CardContent>
                {imgSrc2 != '' ?
                <Grid container spacing={4} direction="column"
                    alignItems="center"
                    justify="center"
                     >
                    <Grid item xs={12}>
                        
                            <img
                                style={{ maxheight: '100%', maxWidth: '100%'}}
                                src={imgSrc2}
                                alt="technical drawing"
                                title="main"
                                
                            />
                        
                    </Grid>
                </Grid> : null}
                </CardContent>
            
            <CardContent>
                <ContentContainer>
                    <Grid container spacing={2}>
                        {
                            selectedMotion !== 'Traveling Loop (Movement in Two Directions)' && (
                                <Grid  item xs={12} lg={4}>
                                    <TextField
                                        label={<span>{`Hose O.D. ( in. )`}</span>}
                                        InputLabelProps={labelProps}
                                        value={getOr('', 'OD', modelInfo)}
                                        disabled
                                        fullWidth
                                    />
                                </Grid>
                            )
                        }
                        <Grid item xs={12} lg={4}>
                            <TextField
                                label={<span>{`Bend Radius-R Dynamic (in.)`}</span>}
                               //value={getOr('', 'BR', modelInfo)}
                               value={BendRadius}
                                InputLabelProps={labelProps}
                                // disabled
                                fullWidth
                                onChange={handleBendRadiusChange}
                                type="number"
                            />
                        </Grid>
                       
                    </Grid>
                    <Grid spacing={2} container>
                        <Grid item xs={(selectedMotion !== 'Angular Motion' ? 6 : 12)}>
                            <TextField 
                                label={`Live Hose Length-L(in.)`} 
                                variant="filled" 
                                InputLabelProps={labelProps}
                                disabled={true}
                                InputProps={inputProps}
                                value={liveHoseLength} 
                                fullWidth
                            />
                        </Grid>
                        {
                            selectedMotion !== 'Angular Motion' && (
                            <Grid item xs={6}>
                                <TextField 
                                    label={outputformatlabel} 
                                    variant="filled" 
                                    InputLabelProps={labelProps}
                                    disabled={true}
                                    InputProps={inputProps}
                                    value={outputFormat} 
                                    fullWidth
                                />
                            </Grid>
                            )
                        }
                    </Grid>
                </ContentContainer>
            </CardContent>
            <CardActions style={{ justifyContent: 'flex-end' }}>
            <Button
                    variant="contained"
                    color="grey"
                    disabled={!inputFormat}
                    style={{ float: 'right' }}
                    onClick={() => window.print()}
                >
                    {'Print'}
                </Button>
                <Button
                    variant="contained"
                    color="grey"
                    disabled={!inputFormat}
                    style={{ float: 'right' }}
                    onClick={reset}
                >
                    {'Reset'}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    disabled={!inputFormat}
                    style={{ float: 'right' }}
                    onClick={calculate}
                >
                    {'Calculate'}
                </Button>
            </CardActions>
        </ThemeWrapper>
    );
}

export default MinLiveLengthCalculator;
